import { Box, Divider, Stack } from "@mui/material";
import { Outlet } from "react-router";
import DashboardLayout from "../../Layouts/Dashboard/dashboard";

function Planning() {
  return (
    <DashboardLayout
      sxContent={{ display: "flex", ".MuiContainer-root": { display: "flex", flexDirection: "column" } }}
      withContainer={false}
    >
      <Box width="100%" display="flex" flexDirection="column">
        <Stack mt={8}>
          <Box pl={3} pr={3}>
            <Stack direction="row" alignItems="center"></Stack>
          </Box>

          <Divider />
        </Stack>
        <Box
          sx={{
            display: "flex",
            flex: 1,
            pl: 3,
            pr: 3,
          }}
        >
          <Outlet />
        </Box>
      </Box>{" "}
    </DashboardLayout>
  );
}

export default Planning;
